var exports = {
  "az": "Box__rPJUBP",
  "wy": "Box_1__VW7SwM",
  "Id": "isDragging__wTlumO",
};

module.exports = exports;
